<template>
	<div style="background-color:#FFF; padding: 20px;">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100 text-center" style="margin-bottom: 20px">
				<h3 class="order-title">របាយការណ៍សង្ខេបអំពីប្រាក់ចំណូលខែ{{config.monthKHList[(new Date()).getMonth()]}}</h3>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="border-collapse: collapse; width: 100%">
					<tr>
						<td class="print-logn-td" style="width: 50%">ប្រាក់ដើមបានទូទាត់</td>
						<td class="print-logn-td" style="width: 50px">:</td>
						<td class="print-logn-td"><b>{{config.moneylify(month.total_paid_principal)}}</b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ការប្រាក់បានទូទាត់</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b>{{config.moneylify(month.total_paid_interest)}}</b></td>
					</tr>
				</table>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="border-collapse: collapse; width: 100%">
					<tr>
						<td class="print-logn-td" style="width: 50%">ប្រាក់ពិន័យបានទូទាត់</td>
						<td class="print-logn-td" style="width: 50px">:</td>
						<td class="print-logn-td"><b>{{config.moneylify(month.total_paid_fine)}}</b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ប្រាក់ចំណូលសរុប</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b>{{config.moneylify(month.total_paid_principal + month.total_paid_interest + month.total_paid_fine)}}</b></td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 20px">
				<h4>តារាងបង់ប្រាក់អតិថិជន</h4>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<table style="border-collapse: collapse; width: 100%;border:1px solid black; font-weight: 9px !important;margin-top: 10px">
					<thead>
						<tr style="border: 1px solid black;padding: 5px">
							<td class="print-row print-row-bold">ល.រ</td>
							<td class="print-row print-row-bold">លេខកូដរំលោះ</td>
							<td class="print-row print-row-bold">ប្រាក់ដើម</td>
							<td class="print-row print-row-bold">ការប្រាក់</td>
							<td class="print-row print-row-bold">ប្រាក់ពិន័យ</td>
							<td class="print-row print-row-bold">ទឹកប្រាក់សរុប</td>
							<td class="print-row print-row-bold">គម្រោង</td>
							<td class="print-row print-row-bold">អតិថិជន</td>
							<td class="print-row print-row-bold">កាលបរិច្ឆេទបង់ប្រាក់</td>
						</tr>
					</thead>

					<tbody v-if="paymentList.length > 0">
						<tr v-for="(payment, index) in paymentList" style="border: 1px solid black">
							<td class="print-row"><b>{{ index + 1 }}</b></td>
							<td class="print-row"><b>{{ payment.hash }}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment.principal) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment.interest) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment.fine)}}</b></td>
							<td class="print-row"><b>{{config.moneylify(payment.principal+payment.interest+payment.fine)}}</b></td>
							<td class="print-row"><b>{{payment.project_name}}</b><br>{{ payment.loan_lot }}</td>
							<td class="print-row"><b>{{payment.client_name}}</b> <br>{{payment.client_hash}}</td>
							<td class="print-row"><b>{{config.datelifyShort(payment.paid_date) }}</b></td>
						</tr>
						<tr style="border: 1px solid black">
							<td class="print-row"></td>
							<td class="print-row"></td>
							<td class="print-row"><b>{{config.moneylify(month.total_paid_principal)}}</b></td>
							<td class="print-row"><b>{{config.moneylify(month.total_paid_interest)}}</b></td>
							<td class="print-row"><b>{{config.moneylify(month.total_paid_fine)}}</b></td>
							<td class="print-row"><b>{{config.moneylify(month.total_paid_principal+month.total_paid_interest+month.total_paid_fine)}}</b></td>
							<td class="print-row"></td>
							<td class="print-row"></td>
							<td class="print-row"></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 20px">
				<h4>តារាងចំណូលតាមគម្រោង</h4>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<table style="border-collapse: collapse; width: 100%;border:1px solid black; font-weight: 9px !important;margin-top: 10px">
					<thead>
						<tr style="border: 1px solid black;padding: 5px">
							<td class="print-row print-row-bold">ល.រ</td>
							<td class="print-row print-row-bold">ឈ្មោះគម្រោង</td>
							<td class="print-row print-row-bold">ប្រាក់ដើម</td>
							<td class="print-row print-row-bold">ការប្រាក់</td>
							<td class="print-row print-row-bold">ប្រាក់ពិន័យ</td>
							<td class="print-row print-row-bold">ប្រាក់ចំណូលសរុប</td>
						</tr>
					</thead>

					<tbody v-if="projectList.length > 0">
						<tr v-for="(project, index) in projectList" style="border: 1px solid black">
							<td class="print-row"><b>{{ index + 1}}</b></td>
							<td class="print-row"><b>{{ project.name }}</b></td>
							<td class="print-row"><b>{{config.moneylify(project.principal) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(project.interest) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(project.fine) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(project.principal+project.interest+project.fine) }}</b></td>
						</tr>
						<tr style="border: 1px solid black">
							<td class="print-row" colspan="2">ចំនួនទឹកប្រាក់សរុប</td>
							<td class="print-row"><b>{{config.moneylify(total_project_principal) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(total_project_interest) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(total_project_fine) }}</b></td>
							<td class="print-row"><b>{{config.moneylify(total_project) }}</b></td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 20px">
				<p>ពេលវេលាទាញយករបាយការណ៍ {{config.datelify((new Date()).getTime()/1000)}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.$http.get(this.config.api + "/admin/get/stat/month").then(data => {
				this.month = data.body.data
			});

			this.$http.get(this.config.api + "/admin/get/stat/month_payment_list").then(data => {
				this.paymentList = data.body.data

				this.$http.get(this.config.api + "/admin/get/stat/month_project_list").then(data => {
					this.projectList = data.body.data
					this.loaded = true;
					setTimeout(() => {
						window.print();
					}, 1000)
				});
			});
		},
		mounted() { },
		data() {
			return {
				loaded: false,
				paymentList: [],
				projectList: [],
				month: {
					total_paid_principal: 0,
					total_paid_interest: 0,
					total_paid_fine: 0
				}
			}
		},
		computed: {
			total_project_principal() {
				let total = 0;

				for(let i =0; i<this.projectList.length; i++) {
					total = total + this.projectList[i].principal;
				}
				return total;
			},
			total_project_interest() {
				let total = 0;

				for(let i =0; i<this.projectList.length; i++) {
					total = total + this.projectList[i].interest;
				}
				return total;
			},
			total_project_fine() {
				let total = 0;

				for(let i =0; i<this.projectList.length; i++) {
					total = total + this.projectList[i].fine;
				}
				return total;
			},
			total_project() {
				return this.total_project_principal + this.total_project_interest + this.total_project_fine
			}
 		}
	}
</script>

<style>
	table {
		page-break-inside:auto;
	}
   tr {
		page-break-inside:avoid;
		page-break-after:auto
	}
   thead {
		display:table-header-group
	}
   tfoot {
		display:table-footer-group
	}

	.no-hover:hover {
		background-color: #FFF !important;
	}
	.center {
		text-align: center;
	}

	body {
		background-color: #FFF !important;
	}
	.print-row-bold {
		font-weight: bold;
	}

	.print-row {
		border: 1px solid black;
		text-align: center;
		padding: 5px;
		font-size: 12px;
	}

	.print-logo {
		height: 100px !important;
		margin: 16px;
	}

	.order-title {
		margin-top: 0;
		margin-bottom: 0;
		font-family: 'Moul';
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
		margin-right: 13px;
	}
	.print-logn-td {
		font-size: 13px;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		padding: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintMonthlyReport.vue